import { useEffect, useRef, useState } from "react";

import styles from './styles.module.scss'
import { Ticket } from "../../../types/tickets/types";
import { TicketStatus } from "../../../constants/ticketStatus";


export enum Action {
    Feedback = 'feedback',
    History = 'history',
    Attach = 'attach',
    Priority = 'priority',
    Direct_channel = 'direct_channel'
}


export type ActionsProps = {
    ticket: Ticket
    userIsMaster: boolean
    onAction: (type: Action, ticket: Ticket, event?: React.MouseEvent<HTMLButtonElement>) => void;
}

export const Actions = ({ ticket, userIsMaster, onAction }: ActionsProps) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const statusValue = TicketStatus[ticket.status as unknown as keyof typeof TicketStatus];


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const onTrigger = (type: Action, event?: React.MouseEvent<HTMLButtonElement>) => {
        onAction(type, ticket, event);
        setOpen(false);
    };


    return (
        <>
            <div style={{ position: "relative", padding: "1rem", display: "inline-block" }} ref={ref}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen(o => !o)
                }}>

                <div
                    className={styles.actionsButton}
                    aria-label="Abrir menu de ações"
                    title="Mais opções"
                >
                    &#x22EE;
                </div>

                {open && (
                    <div className={styles.actionsMenu}>

                        {ticket.referenciaExterna?.trim() != "" && statusValue === TicketStatus["RETORNO"] &&
                            <button
                                className={styles.actionsItem}
                                onClick={() => onTrigger(Action.Feedback)}
                            >
                                Enviar retorno
                            </button>
                        }

                        <button
                            className={styles.actionsItem}
                            onClick={(event) => onTrigger(Action.History, event)}
                        >
                            Consultar Histórico
                        </button>

                        <button
                            className={styles.actionsItem}
                            onClick={() => onTrigger(Action.Attach)}
                        >
                            Adicionar novo anexo
                        </button>

                        {ticket.canalDiretoRespondido && userIsMaster &&
                            <button
                                className={styles.actionsItem}
                                onClick={() => onTrigger(Action.Direct_channel)}
                            >
                                Resposta canal direto
                            </button>
                        }
                    </div>
                )}
            </div>
        </>
    );
}